<span class="f32" size="32">
  <span class="flag {{country.toLocaleLowerCase()}}"></span>
</span>
